import { Divider, Row } from 'antd'
import { FC } from 'react'
import { formatStatisticRowNumber } from '../../../../../util/formatStatisticRowNumber'

import { StatisticRowBox } from './StatisticRowBox'
import Styles from './StatisticRowBox.module.scss'
import { SVGs } from '../../../../../assets'
import { BitazzaText } from '../../../../../components'
import { useTranslation } from 'react-i18next'

interface Props {
    performance: performanceRequestData
}
export const StatisticRowBoxes: FC<Props> = ({ performance }) => {
    const { t } = useTranslation()
    const DATA = [
        {
            id: 1,
            label1: t('txt_n_trades_last_week'),
            value1: formatStatisticRowNumber(
                performance.number_of_trade_week,
                false
            ),
            value1NoFormat: performance.number_of_trade_week,
            value2NoFormat: performance.number_of_trade_month,
            label2: t('txt_n_trades_last_month'),
            value2: formatStatisticRowNumber(
                performance.number_of_trade_month,
                false
            ),
        },
        {
            id: 2,
            label1: t('txt_v_crypto_last_week'),
            value1: formatStatisticRowNumber(
                performance.asset_trade_universe_week,
                false
            ),
            value1NoFormat: performance.asset_trade_universe_week,
            value2NoFormat: performance.asset_trade_universe_month,
            label2: t('txt_v_crypto_last_month'),
            value2: formatStatisticRowNumber(
                performance.asset_trade_universe_month,
                false
            ),
        },
        {
            id: 3,
            label1: t('txt_h_v__trade_last_week'),
            value1: performance.highest_volume_traded_coin_week_symbol || '-',
            label2: t('txt_h_v__trade_last_month'),
            value2: performance.highest_volume_traded_coin_month_symbol || '-',
        },
        {
            id: 4,
            label1: t('txt_max_exposure_last_week'),
            value1: formatStatisticRowNumber(
                performance.max_exposure_avg_WK_pct,
                true,
                '%'
            ),
            value1NoFormat: performance.max_exposure_avg_WK_pct,
            icon: (
                <img
                    src={SVGs.infoFilled}
                    alt="info"
                    width={16}
                    style={{ marginLeft: '6px' }}
                />
            ),
            size: '300px',
            infoContent: (
                <div className={Styles.containerModal}>
                    <div className={Styles.wrapperModal}>
                        <BitazzaText
                            format="t24"
                            color="#FFFFFF"
                            lineHeight={31}
                            content={t('txt_max_exposure_title')}
                            bold
                            textAlign="left"
                        />
                        <Divider className={Styles.dividerText} />
                        <BitazzaText
                            format="t16"
                            color="#FFFFFF"
                            content={t('txt_max_exposure_des1')}
                        />
                        {/* <Divider className={Styles.dividerText} />

                        <BitazzaText
                            format="t16"
                            color="#FFFFFF"
                            content="Investors must remain cognizant of their max exposure to any given asset as it can provide valuable insights into potential risks and returns. By continuously monitoring this metric, investors can make well-informed decisions regarding portfolio rebalancing to manage risks and optimize returns. It is crucial to note that fluctuations in the market can cause changes to an investor's max exposure to an asset, necessitating periodic reviews of the portfolio to ensure alignment with investment goals and risk tolerance levels."
                        /> */}
                    </div>
                </div>
            ),
        },

        {
            id: 5,
            label1: t('txt_risk_last_week'),
            value1: formatStatisticRowNumber(
                performance.risk_on_week,
                true,
                '%'
            ),
            icon: (
                <img
                    src={SVGs.infoFilled}
                    alt="info"
                    width={16}
                    style={{ marginLeft: '6px' }}
                />
            ),
            infoContent: (
                <div className={Styles.containerModal}>
                    <div className={Styles.wrapperModal}>
                        <BitazzaText
                            format="t24"
                            color="#FFFFFF"
                            lineHeight={31}
                            content={t('txt_risk_title')}
                            bold
                            textAlign="left"
                        />
                        <Divider className={Styles.dividerText} />
                        <BitazzaText
                            format="t16"
                            color="#FFFFFF"
                            content={t('txt_risk_des1')}
                        />
                        <Divider className={Styles.dividerText} />

                        <BitazzaText
                            textAlign="left"
                            format="t16"
                            color="#FFFFFF"
                            content={t('txt_risk_des2')}
                        />
                        <Divider className={Styles.dividerText} />
                        <BitazzaText
                            format="t16"
                            color="#FFFFFF"
                            content={t('txt_risk_des3')}
                        />
                    </div>
                </div>
            ),

            value1NoFormat: performance.risk_on_week,
            value2NoFormat: performance.risk_on_month,

            label2: t('txt_risk_monthly'),
            value2: formatStatisticRowNumber(
                performance.risk_on_month,
                true,
                '%'
            ),
        },

        {
            id: 6,
            label1: t('txt_average_n_t_per_week'),
            value1: formatStatisticRowNumber(
                performance.number_of_trade_week_avg,
                true
            ),

            value1NoFormat: performance.number_of_trade_week_avg,
            value2NoFormat: performance.number_of_trade_month_avg,

            label2: t('txt_average_n_t_per_month'),
            value2: formatStatisticRowNumber(
                performance.number_of_trade_month_avg,
                true
            ),
        },
        {
            id: 7,
            label1: t('txt_v_crypto_per_week'),
            value1: formatStatisticRowNumber(
                performance.asset_trade_universe_week_avg,
                true
            ),

            value1NoFormat: performance.asset_trade_universe_week_avg,
            value2NoFormat: performance.asset_trade_universe_month_avg,
            label2: t('txt_v_crypto_per_month'),
            value2: formatStatisticRowNumber(
                performance.asset_trade_universe_month_avg,
                true
            ),
        },
    ]

    return (
        <Row
            justify="space-between"
            gutter={[7, 8]}
            className={Styles.WrapperRow}
        >
            {DATA.map((data) => {
                return (
                    <StatisticRowBox
                        key={data.id}
                        label1={data.label1}
                        label2={data.label2}
                        value1={data.value1}
                        value2={data.value2}
                        value1NoFormat={data.value1NoFormat}
                        value2NoFormat={data.value2NoFormat}
                        icon={data.icon}
                        infoContent={data.infoContent}
                        size={data.size}
                    />
                )
            })}
        </Row>
    )
}
